import {
  RunStepDetailField,
  RunStepDetailFieldList,
} from '../../runHistory/RunStepDetailField';
import type { RunStepDetailProps } from '../../types';
import { getAlertStatusLabel } from './getAlertStatusRunStepSummary';

/** Shows the alert an alert status check read, and the status it read. */
export function GetAlertStatusRunStepDetail({ step }: RunStepDetailProps) {
  const report = step.report?.alert_status_check;
  if (report === undefined) {
    return null;
  }
  return (
    <RunStepDetailFieldList>
      <RunStepDetailField label='Alert ID'>
        {report.alert_id}
      </RunStepDetailField>
      <RunStepDetailField label='Status'>
        {getAlertStatusLabel(report.status)}
      </RunStepDetailField>
    </RunStepDetailFieldList>
  );
}
